import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components
import { withStyles } from "@mui/styles";
import { SnackbarContent as Snack } from "@mui/material";
import { IconButton } from "@mui/material";
import { Icon } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
// @mui/icons-material
import Close from "@mui/icons-material/Close";

import snackbarContentStyle from "./snackbarContentStyle";

class SnackbarContent extends React.Component {
  constructor(props) {
    super(props);
    this.closeAlert = this.closeAlert.bind(this);
    const { classes, message, color, close, icon } = props;
    let action = [];
    if (close !== undefined) {
      action = [
        <IconButton
          className={classes.iconButton}
          key="close"
          aria-label="Close"
          color="inherit"
          onClick={this.closeAlert}
        >
          <Close className={classes.close} />
        </IconButton>,
      ];
    }

    let snackIcon = null;
    switch (typeof icon) {
      case "function":
        snackIcon = <props.icon className={classes.icon} />;
        break;
      case "string":
        if (icon === "info_outline") {
          snackIcon = <InfoOutlined className={classes.icon} />;
        } else {
          snackIcon = <Icon className={classes.icon}>{props.icon}</Icon>;
        }

        break;
      default:
        snackIcon = null;
        break;
    }

    this.state = {
      alert: (
        <Snack
          message={
            <div>
              {snackIcon}
              {message}
              {close !== undefined ? action : null}
            </div>
          }
          classes={{
            root: classes.root + " " + classes[color],
            message: classes.message + " " + classes.container,
          }}
        />
      ),
    };
  }

  closeAlert() {
    this.setState({ alert: null });
  }

  render() {
    return this.state.alert;
  }
}

SnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

export default withStyles(snackbarContentStyle)(SnackbarContent);
